/* eslint-disable max-len */

import React from 'react';
import styled from 'styled-components';
import Container from 'gatsby-theme-core/src/components/container';
import { SalesMen } from '../icons';

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 30px;
  text-align: center;
  text-transform: uppercase;
`;

const ReviewsWrapper = styled.div`
  display: grid;
  grid-auto-rows: auto;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: ${(props) => props.theme.grid.gap};
  overflow-y: scroll;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    overflow-y: visible;
  }
`;

const Review = styled.article`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
  box-shadow: 0px 0px 12px 1px rgba(0,0,0,0.28);
  border-radius: ${(props) => props.theme.borderRadius};
  background-color: white;
  min-width: 280px;
  margin: ${(props) => props.theme.grid.gap} 0;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.lg}) {
    margin: 0;
    min-width: auto;
  }
  &:first-child {
    margin-left: ${(props) => props.theme.grid.gap};
  }
  p {
    line-height: 160%;
  }
  .reviewer {
    display: flex;
    svg {
      width: 30px;
      height: 30px;
      margin-right: 10px;
      color: ${(props) => props.theme.gray2};
    }
    h3 {
      margin: 0;
      font-size: 1rem;
      color: ${(props) => props.theme.primaryColor};
    }

    h4 {
      margin: 0;
      font-size: 1rem;
      font-weight: 400;
      color: ${(props) => props.theme.gray3};
    }
  }
`;

const SeminarReviews = () => (
  <Container>
    <Title>Wat zeggen dealers hierover?</Title>
    <ReviewsWrapper>
      <Review>
        <p>
          “Top seminar gehad bij ons in het bedrijf. Ondanks dat we denken het goed te doen, moeten we nog veel werk verzetten. Even weer lekker met de neus op de feiten gedrukt. Bedankt Paul.”
        </p>
        <div className="reviewer">
          <SalesMen />
          <div>
            <h3>Christiaan Wiefferink Owner</h3>
            <h4>Autobedrijf Wiefferink</h4>
          </div>
        </div>
      </Review>
      <Review>
        <p>
          “Op 10 mei 2017 hebben wij met alle collega&apos;s van Svala, Vireo en Jager Auto een lezing van Paul bijgewoond. Dit was fantastisch! Een heldere inkijk in het klantgedrag en hoe daar efficiënt op reageren.”
        </p>
        <div className="reviewer">
          <SalesMen />
          <div>
            <h3>Rico van der Horst</h3>
            <h4>Vestigingsmanager at Svala Auto</h4>
          </div>
        </div>
      </Review>
      <Review>
        <p>
          “Gisteren Paul persoonlijk gezien en seminarie gevolgd van deze professioneel met alle myCar.be partners. Paul is echt wel goed in de zin dat hij mensen met jarenlange ervaring toch kan boeien omdat het gestaafd is op echte ervaringen en niet louter theorie.”
        </p>
        <div className="reviewer">
          <SalesMen />
          <div>
            <h3>Erwin Engelen</h3>
            <h4>zaakvoerder Garage Ruts Mol</h4>
          </div>
        </div>
      </Review>
    </ReviewsWrapper>
  </Container>
);

export default SeminarReviews;
